<template>
  <b-modal
      id="edit-advanced-break-type"
      ref="edit-advanced-break-type"
      size="sm-size"
      modal-class="advanced-break-modal"
      centered
      hide-footer
      hide-header
      @hide="close"
  >
    <div class="modal-head">
      <h2 class="modal-title">
        {{ label.get('edit_add_break_type') }}
      </h2>
    </div>
    <div class="content-wrapper">
      <div class="form-container">
        <div class="d-flex justify-content-start align-items-center flex-row">
          <div class="check-wrapper frequency-check">
            <b-form-radio
                class="radio-style"
                v-model="item.frequency"
                name="frequency"
                :value="CUSTOM_FREQUENCY"
            >
              {{ label.get('custom') }}
            </b-form-radio>

          </div>
          <div class="check-wrapper frequency-check">
            <b-form-radio
                class="radio-style"
                v-model="item.frequency"
                name="frequency"
                :value="ONCE_DAILY_FREQUENCY"
            >
              {{ label.get('once_daily') }}
            </b-form-radio>

          </div>
        </div>
        <div class="name-holder">
          <span class="heading-title">{{ label.get('name') }}</span>
          <input
              v-model="item.name"
              type="text"
              :placeholder="label.get('add_break_type_name_placeholder')"
              class="atto-input"
          >
        </div>
        <div class="d-flex align-items-center justify-content-between flex-row">
          <div class="break-time-holder">
            <span class="heading-title">{{ label.get('break_time') }}</span>
            <div class="input-wrapper">
              <input
                  v-model="item.break_time"
                  type="number"
                  class="atto-input"
                  name="break-time"
              >
            </div>
          </div>
          <div class="every" v-if="item.frequency === 1">
            <span class="heading-title">{{ label.get('every') }}</span>
            <div class="input-wrapper">
              <time-picker-component
                  class="every-time-picker"
                  v-model="item.every_label"
                  placeholder="04:00"
                  :add-seconds="false"
                  :format24h="true"
                  :required="true"
              />
            </div>
          </div>
          <div class="type-holder">
            <span class="heading-title">{{ label.get('type') }}</span>
            <select-dropdown-component
                :value="item.type"
                placeholder="Select method"
                :options="breakTypes"
                @onOptionSelected="onPaidRulesChanged"
            />
          </div>
        </div>
        <p class="info"
           v-if="item.frequency === 0"
           v-html="
                  label.get('once_daily_info', {
                    break_time: label.get(item.break_time),
                    type: getTypeLabel(item.type)
                  })
                "
        />
        <p class="info"
           v-if="item.frequency === 1"
           v-html="
                  label.get('custom_frequency_info', {
                    break_time: label.get(item.break_time),
                    every: getTimeLabel(),
                    type:  getTypeLabel(item.type),
                  })
                "
        />
      </div>
      <div
          v-if="hasError"
          class="error-wrapper"
      >
        <span class="error-message">
          {{ label.get('please_fill_the_blank_fields') }}
        </span>
      </div>
      <div
          v-if="hasBreakError"
          class="error-wrapper"
      >
        <span class="error-message">
          {{ label.get('break_error') }}
        </span>
      </div>
    </div>
    <div class="modal-footer">
      <div class="form-buttons">
        <button
            class="atto-btn cancel"
            @click="close"
        >
          {{ label.get('cancel') }}
        </button>
        <button
            class="atto-btn submit add-jobs-btn"
            @click="saveChanges"
        >
          {{ label.get('save_changes') }}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import BreakPreferencesService from "../services/BreakPreferencesService";
import SelectDropdownComponent from "../../../../shared/components/SelectDropdownComponent";
import TimePickerComponent from "../../../timesheets/shared/components/TimePickerComponent";

export default {
  name: "EditAdvancedBreakTypeComponent",
  components: {TimePickerComponent, SelectDropdownComponent},
  props: {
    advancedBreakType: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      disabledSaveButton: false,
      breakTypes: this.getBreakTypes(),
      item: Object.assign({}, this.advancedBreakType),
      CUSTOM_FREQUENCY: 1,
      ONCE_DAILY_FREQUENCY: 0,
      hasBreakError: false,
      hasError: false
    }
  },
  mounted() {
    document.body.appendChild(this.$el);
    this.$refs['edit-advanced-break-type'].show();
  },
  methods: {
    getBreakTypes() {
      return BreakPreferencesService.getBreakTypes(this.label);
    },
    onPaidRulesChanged(option) {
      this.item.type = option.value;
    },
    close() {
      this.$root.$emit('hideEditAdvancedBreakType');
    },
    convertH2M(timeInHour) {
      const timeParts = timeInHour.toString().split(":");
      return Number(timeParts[0]) * 60 + Number(timeParts[1]);
    },
    EveryTimeInMinutes() {
      const hm = this.item.every_label;
      return this.convertH2M(hm);
    },
    getTimeLabel() {
      const hm = this.item.every_label;
      const [hoursN, minN] = hm.toString().split(':');
      if (hm !== '') {
        let hours = parseInt(hoursN);
        const minutes = parseInt(minN);

        if (hours === 0 && minutes > 1) {
          return (minutes + ' minutes ');
        }
        if (hours === 0 && minutes === 1) {
          return (minutes + ' minute ');
        }
        if (hours > 1 && minutes === 1) {
          return (hours + ' hours ' + minutes + ' minute ');
        }
        if (hours > 1 && minutes > 1) {
          return (hours + ' hours ' + minutes + ' minutes ');
        }
        if (hours === 1 && minutes === 0) {
          return (hours + ' hour ');
        }
        if (hours === 1 && minutes === 1) {
          return (hours + ' hour ' + minutes + ' minute ');
        }
        if (hours === 1 && minutes > 1) {
          return (hours + ' hour ' + minutes + ' minutes ');
        }
        if (hours > 1 && minutes === 0) {
          return (hours + ' hours ');
        }
        if (hours === 0 && minutes === 0) {
          return '';
        }
      }
    },
    getTypeLabel(type) {
      const typeObj = this.getBreakTypes().find(x => x.value === type);
      if (typeObj) {
        return typeObj.label;
      }
      return 'Unknown';
    },

    saveChanges() {

      const data = this.advancedBreakType;
      if (data.length === 0) {
        this.disabledSaveButton = false;
        this.hasBreakError = true;
        this.hasError = true;
        return;
      }

      const everyTime = parseInt(this.EveryTimeInMinutes());
      const breakTime = parseInt(data.break_time);
      if (everyTime < breakTime) {
        this.disabledSaveButton = false;
        this.hasBreakError = true;
        return;
      }
      this.hasError = false;
      this.hasBreakError = false;
      this.disabledSaveButton = true;
      this.item.every = parseInt(this.EveryTimeInMinutes());
      BreakPreferencesService.updateAdvancedBreakType(this.item.id, this.item).then((response) => {
        this.advancedBreakType.name = this.item.name;
        this.advancedBreakType.type = this.item.type;
        this.advancedBreakType.break_time = this.item.break_time;
        this.advancedBreakType.frequency = this.item.frequency;
        this.advancedBreakType.frequency_label = this.item.frequency_label

        if (this.advancedBreakType.frequency === 1){
          this.advancedBreakType.every_label = this.item.every_label;
          this.advancedBreakType.every = this.item.every;
        }
        this.$root.$emit('hideEditAdvancedBreakType', response);
      }).catch((error) => {
        this.disabledSaveButton = false;
        console.log('Error updating break code.');
      })
    }
  }
}
</script>
